import { render, staticRenderFns } from "./CuotasReport.vue?vue&type=template&id=4bfc93f0&scoped=true"
import script from "./CuotasReport.vue?vue&type=script&lang=js"
export * from "./CuotasReport.vue?vue&type=script&lang=js"
import style0 from "./CuotasReport.vue?vue&type=style&index=0&id=4bfc93f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc93f0",
  null
  
)

export default component.exports